export default {
	termsAndConditions: {
		lastUpdate: 'Последна актуализация: 10 юни 2024 г',
		content: `
		<p>Условията, които ще намерите по-долу, са важни, защото:</p>
		<ul>
			<li>Те установяват своите законни права в {siteName}.</li>
			<li>Обяснете правата, които ни предоставяте, когато използвате {siteName}.</li>
			<li>
				Те описват правилата, които всеки трябва да спазва, когато използва {siteName}.
			</li>
		</ul>
		<p>
			Моля, прочетете внимателно тези Условия, както и нашите {privacyPolicyLink} и всички други
			документи, посочени в настоящите Условия.
		</p>
		<p>Да започваме...</p>
		<h3>1. ВЪВЕДЕНИЕ И ДАННИ НА {siteNameUpper}.</h3>
		<p>
			Уебсайтът {websiteLink} (наричан по-долу „Уебсайтът“) е собственост на компанията
			{siteName} S.L (наричано по-долу „{siteName}“), компания
			регистрирано в съответствие с испанското законодателство с адрес Avenida de
			Cerdanyola, nº 75, 1º, Sant Cugat del Vallès (Барселона), притежател на CIF номер
			B-56.768.260 и регистриран в търговския регистър на Барселона в том
			49065, фолио 0033, лист B-606324, 1-ва регистрация.
		</p>
		<p>
			{siteName} предоставя уебсайта на ваше разположение, за да можете да стигнете до него
			познавайте ни по-добре, познавайте услугите, които предоставяме и ако желаете, можете да се свържете с нас
			и, когато е подходящо, сключете договор с нас.
		</p>
		<h3>2. ЦЕЛ И ОБХВАТ НА ПРИЛОЖЕНИЕ НА УСЛОВИЯТА ЗА ПОЛЗВАНЕ</h3>
		<p>
			Тези условия за използване представляват, заедно с {privacyPolicyLink} и
			{cookiesPolicyLink}, правната рамка, която регулира използването на уебсайта
			{websiteLink}. Тези условия за използване ще бъдат достъпни за вас на уебсайта
			на английски, така че да можете да ги консултирате, архивирате или отпечатате по всяко време и
			когато поискаш.
		</p>
		<p>
			За да знаете всякакви въпроси относно лечението, извършвано от {siteName}.
			на вашите лични данни, моля, посетете нашите {privacyPolicyLink} и нашите {cookiesPolicyLink}.
			И двете политики ще ви бъдат достъпни и на английски, за да можете
			консултирайте се, архивирайте или ги отпечатайте по всяко време.<br />
			{siteName} използва бисквитки на трети страни на уебсайта. За да разберете повече
			относно типа бисквитки, използвани в мрежата {websiteLink}, тяхната цел и как
			за да конфигурирате браузъра си, в случай че не искате да използваме тези бисквитки,
			моля, посетете нашата {cookiesPolicyLink}.
		</p>
		<p>
			И двете условия за използване, както и {privacyPolicyLink} и 
			{cookiesPolicyLink} са изготвени в съответствие с разпоредбите на настоящите
			приложими разпоредби, наред с други, Закон 34/2002 за услугите на
			Информационно общество и електронна търговия и Регламент (ЕС) 2016/679 от
			на Европейския парламент и на Съвета от 27 април 2016 г. относно
			защита на физически лица по отношение на обработката на лични данни
			данни и свободното разпространение на тези данни и с които Директива 95/46 / CE
			се отменя.
		</p>
		<h3>3. ДОСТЪП ДО УЕБСАЙТА И ПРИЕМАНЕ</h3>
		<p>
			Достъпът до уебсайта е безплатен с изключение на частта, свързана с цената на
			връзка чрез телекомуникационната мрежа, предоставена от Интернет
			доставчик на достъп, с който сте сключили договор. Можете свободно да разглеждате уебсайта
			и достъп до него толкова пъти, колкото искате. За достъп и навигация в уебсайта,
			не е необходимо да се регистрирате, освен ако искате да наемете услуга.
		</p>
		<p>
			Използването на уебсайта ви дава състоянието на потребител на уебсайта
			(наричан по-нататък „Потребител“) и предполага пълно и безрезервно приемане от ваша страна на
			тези условия за използване, както и {privacyPolicyLink} и {cookiesPolicyLink}
			на уебсайта. Освен това вие се съгласявате да не използвате Услугата за незаконни цели
			цели.
		</p>
		<p>
			Чрез достъпа до уебсайта и разглеждането му вие декларирате под своя
			отговорност, че сте пълнолетен и че имате необходимата правна
			възможност за достъп до Уебсайта и да го използвате, като също така декларирате, че напълно
			разберете и приемете тези условия за ползване без резерви.
		</p>
		<p>
			От друга страна, ние ви информираме, че по правни причини архивираме
			електронни документи, в които се формализират покупките. Можете да получите достъп
			тези документи по всяко време, като ги поискате на: {supportLink}.
		</p>
		<h3>4. УСЛОВИЯ ЗА ПОЛЗВАНЕ НА УЕБСАЙТА</h3>
		<p>
			Потребителят се съгласява да използва уебсайта в съответствие с тези условия за ползване,
			действащото законодателство и добросъвестност. Така Потребителят ще отговори на {siteName}.
			 и пред всяка трета страна за щетите и загубите, произтичащи от
			използването в противоречие с тези условия, законодателството и добросъвестността
			от Потребителя на уебсайта.
		</p>
		<h3>5. ОПИСАНИЕ НА УСЛУГАТА</h3>
		<p>
			Чрез Услугата {siteName} позволява абонамент за услугата за
			извършете редактиране на изображения.
		</p>
		<p>
			Езикът, на който е договорът между {siteName} и купувача
			ще се заключи, че ще бъде тази на страната на произход.<br />
			Процесът на покупка в онлайн услугата ще бъде както следва:
		</p>
		<ol>
			<li>Трябва да се регистрирате на уебсайта с потребителско име и парола.</li>
			<li>
				При регистрацията потребителят трябва да избере един от плановете за плащане
				в секцията Цени и ще Ви бъдат предоставени кредити в зависимост от
				избран план. Всеки кредит ще ви позволи да редактирате едно изображение.
			</li>
			<li>
				След закупуване на услугата, потребителят ще има администрация
				панел, където ще намерят:
				<ul>
					<li>
						Секция със списък на всички изображения, които са били обработени, като
						можете да го редактирате толкова пъти, колкото искате, и да го изтеглите на вашия
						устройство.
					</li>
					<li>
						Раздел от Планове и плащания за преглед на фактурите и анулиране на
						абонамент.
					</li>
					<li>Секция от Моят акаунт, за да можете да променяте предпочитанията на акаунта.</li>
				</ul>
			</li>
		</ol>
		<p>
			След като покупката на услугата бъде направена, тя ще бъде потвърдена от
			изпращане на имейл, в рамките на максимален период от 24 часа, на адреса, който имате
			посочено. Ще посочи услугата, как да отмените абонамента, нейната
			сума, приложимите данъци, формата на плащане и приложимите условия и
			условия.
		</p>
		<h4>5.1 Абонамент</h4>
		<p>
			Абонаментът за услугата варира в зависимост от избрания план и ще бъде
			автоматично се подновява за същия период от време до прекратяването му.
			Освен ако не анулирате абонамента си, вие ни разрешавате да заредим
			съответната годишна абонаментна такса във вашия начин на плащане.
		</p>
		<p>
			Можете да отмените абонамента си за Услугата по всяко време и ще го направите
			продължете да имате достъп до него до края на годишния период на фактуриране. Да се
			до степента, разрешена от закона, плащанията не подлежат на възстановяване и ние не предоставяме
			възстановяване на средства или кредити за частични годишни абонаментни периоди.
		</p>
		<h3>6. ЦЕНА И ДАНЪЦИ</h3>
		<p>
			Цените на предлаганите продукти на {siteName} са посочени в евро
			(€) или валутата на държавата, от която е направена покупката, Стойността
			Данъкът върху добавената стойност (ДДС), който е в сила към момента на покупката, се начислява върху цената на
			продукти.
		</p>
		<p>
			Във всеки случай операцията може да бъде освободена или да не подлежи на ДДС в зависимост от това
			вашата страна на пребиваване или състоянието, в което действате. Поради тази причина,
			в някои случаи крайната цена на поръчката може да бъде променена по отношение на
			един показан.<br />
			Покупките, извършени от субекти, освободени от плащане на ДДС, ще означават това с
			изпращане на техния ДДС/NIF номер по имейл до {supportLink}, без запис
			покупки с посочения данък.
		</p>
		<h3>7. НАЧИН НА ПЛАЩАНЕ</h3>
		<p>
			Онлайн плащането на закупената услуга може да се извърши с кредитна или дебитна карта.
			В този смисъл {siteName} информира притежателите на кредитни и дебитни карти, че
			транзакциите в онлайн магазина се извършват чрез сигурно плащане
			шлюз, използващ SSL технология, за да гарантира сигурността на предаването на данни.
		</p>
		<h3>8. ПРАВО НА ОТТЕГЛЯНЕ И ВЪЗСТАНОВЯВАНЕ НА СУМИТЕ</h3>
		<h4>8.1. Право на отказ</h4>
		<p>
			Като се има предвид вида на продукта, предлаган на пазара в нашата онлайн услуга, софтуерът е цифров
			формат на QR, правото на отказ няма да бъде приложимо съгласно
			член 103, буква m) от Кралски законодателен указ 1/2007 от 16 ноември, от
			че преработеният текст на Общия закон за защита на потребителите и
			Потребителите и други допълнителни закони са одобрени.
		</p>
		<h4>8.2. Възстановяване на средства</h4>
		<p>
			Независимо от плана, избран от потребителя, сумите, платени от потребителя и до
			степента, разрешена от закона, няма да бъде възстановена.
		</p>
		<p>
			Договорената услуга не може да бъде възлагана или прехвърляна на други потребители на
			услугата.
		</p>
		<p>
			Във всеки случай потребителят може да се възползва от договорената услуга до края на
			договорения период.
		</p>
		<h3>9. ВАЛИДНОСТ НА ОФЕРТИТЕ</h3>
		<p>
			Услугите, предлагани в Услугата, и техните цени ще бъдат достъпни за
			купуват, докато са в каталога на услугите, показан чрез това
			уебсайт.
		</p>
		<p>
			Във всеки случай {siteName} си запазва правото да прави промени в него
			счита за подходящо в Услугата, като може да актуализира продукти и услуги
			в зависимост от пазара.
		</p>
		<p>
			{siteName} си запазва правото да променя цените без предизвестие. Ние
			Ви информираме, че въпреки актуализациите, които се правят на цените на
			Обслужване, може да съдържат грешки. Ние незабавно ще коригираме всички грешки, които
			се появяват, но те няма да бъдат обвързващи за Услугата.
		</p>
		<h3>10. БЕЗОПАСНОСТ</h3>
		<p>
			Както беше посочено по-горе, цялата процедура за покупка, както и предаването
			на вашите лични данни и платежни системи, се извършва на защитена страница и
			по криптиран начин чрез SSL протокола.
		</p>
		<p>
			Ние гарантираме сигурността на Услугата в съответствие с настоящите
			технологични познания. {siteName} обаче не може да гарантира пълното
			бъдеща сигурност на услугата. Във всеки случай обещаваме да коригираме и
			приложете подходящите коригиращи мерки, за да коригирате евентуална сигурност
			нарушение възможно най-скоро.
		</p>
		<p>
			Вие се съгласявате да уведомите {siteName} незабавно и чрез имейл {supportLink}
			за всяка ситуация, която може да доведе до представяне на самоличността на потребителя.
		</p>
		<h3>11. МОДИФИКАЦИИ И НИЩОЖНОСТ</h3>
		<p>
			Възможно е също да актуализираме правилата и условията на Услугата в бъдеще
			като характеристиките и функциите на самата услуга.
		</p>
		<p>
			Ние ще ви информираме за промените в правилата и условията чрез известие
			на видно място на нашия уебсайт и/или по имейл.
		</p>
		<p>
			Ако някоя клауза, включена в тези правила и условия, бъде декларирана, напълно или
			частично, нищожно или неефективно, то ще засегне само споменатата разпоредба или част
			от него, което е нищожно или неефективно. Правилата и условията ще останат в сила
			всичко останало, имащо такава разпоредба, или частта от нея, която е засегната, от
			не се поставят.
		</p>
		<h3>12. ИСКОВЕ И ДЕЙСТВИЯ, ПРОИЗТИЧАЩИ ОТ ДОГОВОРА</h3>
		<p>
			Доколкото е възможно, тази услуга се урежда от испанското законодателство.<br />
			За да се опрости разрешаването на искове чрез гражданско производство и
			намаляване на разходите, ние не изключваме възможността да се подложим на an
			Арбитраж за справедливост към Арбитражния съд на търговските камари и
			Индустрия. В този смисъл и съгласно действащата нормативна уредба,
			 {siteName} информира за съществуването на европейско онлайн разрешаване на спорове
			платформа, която улеснява извънсъдебното разрешаване на такива спорове за
			договори, сключени и онлайн между потребители и интернет услуга
			доставчици. Тази платформа може да бъде достъпна чрез следния уебсайт:
			<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
		</p>
		<h3>13. ПРАВА НА ИНТЕЛЕКТУАЛНА И ИНДУСТРИАЛНА СОБСТВЕНОСТ</h3>
		<p>
			Уебсайтът и неговото съдържание са обект на защита при прилагане на
			действащите национални разпоредби относно интелектуалната и/или индустриалната собственост, т.к
			както и при прилагане на международните конвенции, приложими в такива
			въпроси. {siteName} е собственик или е надлежно лицензирал всички
			Права на интелектуална и индустриална собственост върху уебсайта и неговото съдържание.
		</p>
		<p>
			Всяка форма на възпроизвеждане, разпространение, публично съобщаване, трансформиране,
			предоставяне на разположение и като цяло всеки друг акт на експлоатация, независимо дали е или не
			за търговски цели на уебсайта или неговото съдържание, без предварително
			изрично съгласие на {siteName}. Изрично е забранено изтриването на
			идентифициращи данни на {siteName} като собственик на интелектуалния и
			Права на индустриална собственост на уебсайта или неговото съдържание.
		</p>
		<p>
			{siteName} си запазва всички права върху интелектуална и индустриална собственост
			върху Уебсайта и неговото съдържание, като също си запазва упражняването на всякакви правни
			действия, които съответстват на него, за да прекратят, предотвратят или наказателно преследват
			незаконно използване на уебсайта или неговото съдържание. В никакъв случай и под бр
			обстоятелства прави достъп до уебсайта или използването му от потребителя или трети
			страни представляват или предполагат прехвърляне от всякакъв вид от {siteName} на
			правата на интелектуална или индустриална собственост на уебсайта или неговото съдържание.
			В никакъв случай липсата на изискване от {siteName} да прекрати използването на
			Уебсайтът или неговото съдържание могат да бъдат незаконни или противоречащи на тези условия
			разбирано като мълчаливо съгласие от {siteName} за такива употреби или като отказ
			за упражняването на всяко правно действие, което може да съответства на това.
		</p>
		<h3>14. ОТГОВОРНОСТИ И ГАРАНЦИИ</h3>
		<p>
			Потребителят трябва да използва уебсайта и неговото съдържание в съответствие с
			разпоредбите на тези условия за ползване, действащото законодателство и добросъвестността. Всякакви
			използване на уебсайта или неговото съдържание в противоречие с тези общи условия,
			законът или добросъвестността са изрично забранени, независимо дали споменатата употреба има
			икономическа цел или не.<br />
			Потребителят ще носи отговорност за всички щети или вреди, причинени на {siteName}
			 или на трети страни, получени пряко или косвено от каквато и да е употреба
			че Потребителят прави на уебсайта или неговото съдържание в противоречие с тях
			условия, закон, морал, обществен ред или добросъвестност.
		</p>
		<p>
			За да бъдат уебсайтът и неговото съдържание достъпни за потребителя, {siteName}
			 изисква услуги, предоставени от трети страни. Възможно е това
			въпреки усилията, положени от {siteName} да поддържа уебсайта достъпен
			и достъпен за потребителите, неговата наличност може да бъде спряна, прекъсната или
			отменен по причини извън {siteName}. Ето защо {siteName}
			не гарантира липсата на прекъсвания или грешки при достъпа до
			Уебсайт или неговото съдържание, нито че са актуализирани или винаги се показват в
			последната им версия. Следователно {siteName} отказва всички
			отговорност за щети, които могат да бъдат причинени на Потребителя или на трети страни като
			в резултат на спиране, прекъсване, липса на непрекъснатост, прекъсване на мрежата
			или прекъсване на връзката с уебсайта.
		</p>
		<p>
			В никакъв случай и при никакви обстоятелства {siteName} няма да носи отговорност за
			щети или загуби, произтичащи от потребителя поради причини, които не могат да бъдат приписани на {siteName}
			 като например и в никакъв случай ограничаващи, естествени
			бедствия, ситуации на непреодолима сила или изключителна спешност, вируси, вредни
			компоненти, неизправности на браузъра, прекъсване на мрежата, компютърни прониквания или
			атаки на трети страни.
		</p>
		<h3>15. ВРЪЗКИ</h3>
		<p>
			Уебсайтовете, платформите, форумите, чатовете, блоговете или външните социални мрежи, които
			връзката или връзката към уебсайта трябва ясно да информират, че нямат
			упълномощаване или надзор на {siteName} и споменатото свързване или
			връзката не предполага, предполага или предполага връзка от какъвто и да е вид между {siteName}
			 и уебсайтове, платформи, форуми, чатове, блогове или външни
			социални мрежи, които свързват или препращат към уебсайта.
		</p>
		<p>
			Във всеки случай, всяка връзка, която е предназначена за уебсайта, трябва да бъде насочена
			директно към началната страница или началната страница на уебсайта, като щракнете върху URL адреса
			на уебсайта, покриващ целия екран на началната страница или началната страница на
			уебсайта, така че връзката да е абсолютна и пълна без използване на
			рамки, рамки или хипервръзки. {siteName} не отговаря в никакъв случай
			и при всякакви обстоятелства на съдържанието, информацията или данните, свързани с
			уебсайт, неговото съдържание или всяка друга материя, съдържаща се в уебсайтовете, платформите,
			форуми, чатове, блогове или социални мрежи на трети страни, които свързват или препращат към
			уебсайт.
		</p>
		<p>
			Изрично е забранено поставянето на връзки или връзки към уебсайта от уебсайтове,
			платформи, форуми, чатове, блогове или социални мрежи, противоречащи на закона, морала
			и добри обичаи, особено тези с порнографски, незаконни, незаконни или
			съдържание, нарушаващо правата на човека.
		</p>
		<p>
			От друга страна, уебсайтът може да съдържа връзки към уебсайтове на трети страни,
			платформи, форуми, чатове, блогове или социални мрежи. {siteName} не го прави
			разполагат с човешки и/или технически средства, за да познават или контролират информацията и
			съдържание, което се появява на уебсайтове на трети страни. Следователно в никакъв случай {siteName}
			 носи отговорност за съдържанието на свързаните сайтове и под бр
			обстоятелства могат споменатите връзки да се считат за ефективно познаване на съдържанието
			на сайтовете, към които препращат.
		</p>
		<h3>16. ЗАЩИТА НА ДАННИТЕ</h3>
		<p>
			Както е посочено в {privacyPolicyLink}, {siteName} се задължава да използва потребителя
			данни, да спазва тяхната поверителност и да ги използва в съответствие с
			цел на лечението, както и да изпълни задължението си да го запази.
			и адаптирайте всички мерки, за да избегнете промяна, загуба, обработка или неоторизирано
			достъп в съответствие с разпоредбите на действащото законодателство относно
			защита на личните данни.
		</p>
		<p>
			Уебсайтът включва подходящи предпазни мерки и използва индустриален стандарт
			технология за подобряване на сигурността, целостта, пълнотата, точността и
			защита на личните данни, които е събрал и установил
			разумни предпазни мерки за защита на тази информация от възможна загуба или
			злоупотреба. Неговите правила относно защитата на данните и сигурността се преразглеждат периодично
			и се подобрява, когато е необходимо, и се стреми да гарантира, че само оторизирани
			лица имат достъп до информацията, предоставена от потребителя.
		</p>
		<p>
			За да научите повече за управлението и лечението, извършвано от {siteName}
			 на вашите данни, моля, прочетете нашите {privacyPolicyLink} и нашите {cookiesPolicyLink}.
		</p>
		<h3>17. ПРОДЪЛЖИТЕЛНОСТ И МОДИФИКАЦИЯ</h3>
		<p>
			Тези условия за употреба ще бъдат в сила, докато са изложени на
			потребители, така че веднага след като те бъдат напълно или частично променени или актуализирани,
			тези условия ще престанат да бъдат в сила, тъй като са новите условия за използване
			тези, които продължават да регулират използването на уебсайта.
		</p>
		<p>
			{siteName} си запазва правото да ги преглежда, променя или актуализира
			условия за използване по всяко време. В случай на промяна на тези условия
			за използване по някаква причина, {siteName} ще уведоми потребителите на началната страница
			мрежата за посоченото обстоятелство, за да бъдат надлежно информирани и да могат да се консултират
			ревизиите, модификациите или актуализациите на настоящите условия за използване на
			вашето удовлетворение.
		</p>
		<h3>18. ОБЩИ</h3>
		<p>
			В никакъв случай и при никакви обстоятелства липсата на упражняване на вашите права
			от {siteName} да се разбира като отказ от тях.
		</p>
		<p>
			Заглавията, съдържащи се в тези условия, са само ориентировъчни или
			информативни, така че да не засягат, квалифицират или разширяват тълкуването
			от това.
		</p>
		<p>
			В случай, че някоя от клаузите, съдържащи се в тези условия, е била
			обявени за нищожни, злоупотребяващи или неприложими, изцяло или частично, от съдебен
			или административен орган, посочената декларация ще засегне индивидуално клаузата
			под въпрос, приемайки го за не и без обявяване на нищожност, злоупотреба или
			неприложимостта се разширява при всякакви обстоятелства към останалата част
			условия, които ще съществуват.
		</p>
		<p>
			Тези условия за използване, както и {privacyPolicyLink} и {cookiesPolicyLink}
			се управляват от действащите испански разпоредби по всяко време.
		</p>
		<h3>19. ОБСЛУЖВАНЕ НА КЛИЕНТИ</h3>
		<p>
			За всяко уточнение, инцидент или иск можете да се свържете с нас чрез:<br />
			Имейл: {supportLink}<br />
			Пощенски адрес: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Барселона, Испания.
		</p>`
	},
	privacyPolicy: {
		lastUpdate: 'Последна актуализация: 10 юни 2024 г',
		content: `
			<h3>1. Отговорна страна и описание</h3>
			<h5>1.1. Отговорен</h5>
			<p>Лицето, отговорно за обработката на този сайт, е Remove Background S.L (наричано по-нататък Премахване на фона 
			или Услугата), с адрес на ул. Ав. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Барселона, Испания.</p>
			<p>NIF: B56768260<br> Имейл: {supportLink}</p>

			<h5>1.2. Описание</h5>
			<p>Приемането на правилата за поверителност на Премахване на фона (наричани по-долу „Правила за поверителност“) е необходимо условие 
				за използването на нашия уебсайт и предоставянето на услугата (наричана по-долу „Услугата“).<br>
				Тази Политика за поверителност регулира събирането, обработката и използването на вашата лична и нелична информация 
				като потребител на Премахване на фона, считано от датата на влизане в сила, която се появява в заглавката.<br>
				За да обработва вашите лични данни, Remove Background спазва действащото местно и европейско законодателство, 
				както и разпоредбите за неговото прилагане.</p>


			<h3>2. Събраната информация</h3>
			<p>Достъпът до нашия уебсайт може да бъде направен без необходимост от предоставяне на каквато и да е информация, въпреки че трябва да се регистрирате и / 
				или договорете нашите планове, ще трябва да ни предоставите някои лични данни. Информацията (лична 
				или нелични), събрани от Услугата, може да варират в зависимост от това.<br>
				Личната и неличната информация, събрана от Услугата, ще дойде при нас по три начина: 1) това, което 
				се събира автоматично 2) това, което ни предоставяте доброволно и 3) това, което е предоставено от трети страни.</p>

			<h5>2.1. Този, който се събира автоматично</h5>
			<p>Тази информация ще се състои от:</p>
			<ul>
				<li>Този, който се събира чрез бисквитки или подобни механизми, съхранявани на вашето устройство, винаги с вашето съгласие или в 
					в съответствие с други правни основания. Вижте нашата Политика за бисквитки за повече информация.</li>
				<li>IP адресът, от който се осъществява връзката, вида на използваното устройство и неговите характеристики, версията на 
					операционната система, вида на браузъра, езика, датата, държавата, часа на заявката, 
					URL адресът от това, от което идвате, URL адресът, към който отивате, или използваната мобилна мрежа, между другото.</li>
				<li>Данни за използването на услугата и възможни грешки, открити по време на нейното използване.</li>
				<li>В допълнение, Remove Background използва Google Analytics, аналитична услуга, предоставяна от Google, LLC. 
					установен в Съединените щати със седалище на 1600 Amphitheatre Parkway, Mountain View, California 94043. 
					За предоставянето на тези услуги те използват бисквитки, които събират информация, включително IP адреса на потребителя, 
					които ще бъдат предадени, обработени и съхранени от Google съгласно условията, установени в мрежата www.google.com. 
					Включително възможното предаване на посочената информация на трети страни по причини на законово изискване или 
					когато споменатите трети страни обработват информацията от името на Google.</li>
			</ul>
			<p>Във всеки случай можете да деактивирате бисквитките на Google Анализ от <a href="{externalLink: disableGoogleAnalyticsLink}">тук</a>.</p>

			<h5>2.2. Тази, която предоставяте доброволно</h5>
			<p>Тази информация ще се състои от:</p>
			<ul>
				<li>Всички данни са задължителни.</li>
				<li>Това, което се изисква от Remove Background, за да завършите регистрацията си в мрежата: име и фамилия, адрес и имейл, наред с други.</li>
				<li>Всички данни са задължителни.</li>
				<li>Информацията, лична или не, за завършване на договарянето на услугата, като вашия имейл адрес и номера на вашата кредитна или дебитна карта.</li>
				<li>Информацията, лична или не, която съобщенията, изпратени чрез каналите за контакт или мнение, установени в Услугата, могат да съдържат, 
					например вашето име и имейл.</li>
			</ul>

			<h5>2.3. Този, предоставен от трети страни</h5>
			<p>Тази информация ще се състои от:</p>
			<ul>
				<li>Този, предоставен от платежни системи или процесори за кредитни карти, като например времето на покупката или нейната сума.</li>
			</ul>


			<h3>3. Права и цели</h3>
			<p>Информираме ви, че попълването на формулярите е доброволно. Ако обаче не попълните задължителните полета 
				(обикновено отбелязано със звездичка), използването на някои функции на Услугата няма да бъде възможно или ще бъде ограничено.<br>
				Личните данни, които ни предоставяте, ще бъдат включени и обработени в Регистъра на лечебните дейности на Премахване на фона 
				за да можем да обслужим вашите заявки, да предоставим заявената услуга и да ви информираме за въпроси, свързани с дейността 
				на компанията и нейните услуги.<br>
				Можете да упражнявате по всяко време правата на достъп, коригиране, изтриване, ограничаване на вашето лечение, 
				противопоставяне и преносимост на вашите лични данни чрез имейл, адресиран до: {supportLink} или пощенския адрес: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Барселона, Испания.<br>
				И в двата случая трябва да се легитимирате с вашето име и фамилия, както и копие на вашия DNI или национална лична карта, ако е необходимо.<br>
				В случай, че сте дали съгласие за конкретна цел, имате право да оттеглите съгласието по всяко време, 
				без това да засяга законосъобразността на лечението въз основа на съгласието преди оттеглянето му.<br>
				Освен това, ако смятате, че има проблем с начина, по който Remove Background обработва вашите данни, 
				можете да насочите жалбите си към <a href="{knowYourRightsLink}">органа за защита на данните</a>, който съответства, който е <a href="{aepdLink}">Испанската агенция за защита на данните</a> 
				този, посочен в случая на Испания.</p>


			<h3>4. Възраст</h3>
			<p>По отношение на използването на онлайн услугата вие декларирате, че сте пълнолетен и че имате необходимите правни 
				способността да се обвържете с това споразумение и да използвате сайта в съответствие с неговите правила и условия, които вие напълно 
				разбирам и признавам.<br>
				Вие декларирате, че цялата информация, която предоставяте за достъп до Услугата, преди и по време на нейното използване, е вярна, пълна 
				и точен.</p>


			<h3>5. Използване на данни</h3>
			<p>Премахване на фон ще използва събраните данни за:</p>
			<ul>
				<li>Управлявайте и актуализирайте Услугата (правното основание е нашият законен интерес да поддържаме и поддържаме Услугата 
					актуален и в добро състояние).</li>
				<li>Отговорете на въпросите, които повдигате (правното основание е нашият законен интерес да обслужваме исканията и 
					съмнения на нашите потребители).</li>
				<li>Обработване на плащанията, които правите (правното основание е договорът).</li>
				<li>Предоставете договорената услуга (договорът е правното основание).</li>
				<li>Поддържайте сигурността на Услугата, разследвайте незаконни дейности, налагайте нашите правила и условия и
					помогне на силите за държавна сигурност в рамките на техните възможни разследвания (правното основание е нашето 
					легитимен интерес за гарантиране и поддържане на сигурността на Услугата и нейните потребители).</li>
			</ul>
			<p>Премахване на фона не използва автоматизирани решения, въпреки че може да генерира основни потребителски профили, 
				правното основание е нашият легитимен интерес за търговски цели и предоставяне на персонализирани оферти.<br>
				Също така, Remove Background може да използва потребителска информация под формата на обобщени и анонимни данни, за да я покаже на трети страни. 
				Можете също така да споделяте статистически данни и демографска информация за потребителите и тяхното използване на Услугата с трети страни. 
				Но нищо от това няма да позволи на тези трети страни да ви идентифицират лично.</p>

			<h5>5.1. В имейли и формуляри за контакт</h5>
			<p>Уеб сайтът има SSL криптиране, което позволява на потребителя да изпраща своите лични данни сигурно чрез стандартни форми за контакт.<br>
				Събраните лични данни ще бъдат обект на автоматизирана обработка и включени в съответните файлове 
				на записа на дейностите по обработка и на който Премахване на фона е собственик.</p>
			<p>В този смисъл:</p>
			<ul>
				<li>Ще получим вашия IP адрес, който ще бъде използван за проверка на произхода на съобщението, за да ви предложим адекватно 
					препоръки (например представяне на информацията на правилния език) и за откриване на възможни нередности 
					(например възможни опити за кибератака на услугата), както и данни, свързани с вашия интернет доставчик.</li>
				<li>По същия начин можете да ни предоставите вашите данни по телефон, имейл или други посочени средства за комуникация.</li>
			</ul>
			<p>Относно използваното средство за плащане:</p>
			<ul>
				<li>Нашите доставчици на платежни услуги за плащане за предоставянето на нашите услуги са кредитни или дебитни карти. 
					В никакъв момент Услугата или нейният персонал няма да имат достъп до банковите данни (например номера на кредитната карта) 
					които потребителят като клиент ще предостави на тези трети страни.</li>
			</ul>


			<h3>6. Запазване на данни</h3>
			<p>По-долу са посочени колко дълго се съхраняват данните, обработвани от Услугата:</p>
			<ul>
				<li>Разделените данни ще се съхраняват без период на изтриване.</li>
				<li>
					Клиентските данни ще се съхраняват за необходимия минимум и могат да се съхраняват до:
					<ul>
						<li>5 години, съгласно чл. 1964 от Гражданския кодекс (лични искове без специален срок).</li>
						<li>6 години, съгласно чл. 30 от Търговския закон (например счетоводни книги или фактури).</li>
					</ul>
				</li>
				<li>Потребителските данни ще се съхраняват за максимален период от 12 месеца, за да могат да бъдат изпълнени техните заявки.</li>
			</ul>


			<h3>7. Данни, споделени с трети страни</h3>
			<p>Има трети страни, които управляват част от Услугата.<br>
				Премахването на фона изисква от тях да спазват тази Политика за поверителност, както е приложимо, в допълнение към притежаването на собствена. Премахване на фона обаче няма да носи отговорност за спазването на споменатата политика.<br>
				При определени обстоятелства Remove Background може да сподели, използва или запази с трети страни всяка от събраната лична информация:</p>
			<ul>
				<li>За да предоставите Услугата:</li>
			</ul>
			<p>Доставчици на услуги, които изпълняват функции от наше име, като платежни услуги, уеб хостинг, бизнес анализи, обслужване на клиенти или уеб маркетинг. Тези доставчици на услуги могат да събират и да имат достъп до информацията, която им е необходима, за да изпълняват функциите си, но не им е разрешено да споделят или използват информацията за други цели.</p>
			<ul>
				<li>Да си сътрудничим с компетентните органи:</li>
			</ul>
			<p>Ако смятаме, че е разумно необходимо да удовлетворим всеки закон, правен процес или легитимен интерес. Във всеки случай ние ще предоставим само строго необходимата информация.</p>


			<h3>8. Мерки за сигурност</h3>
			<p>Премахване на фона приема всички технически и организационни мерки, необходими за
				защита на сигурността и целостта на събраната лична и нелична информация. 
				Както срещу неоторизиран достъп, така и срещу неговата случайна промяна, загуба или унищожаване.<br>
				Във всеки случай Remove Background не може да гарантира абсолютната сигурност на събраната информация, 
				така че трябва да си сътрудничите и да използвате здрав разум относно споделената информация по всяко време.<br>
				Вие разбирате и потвърждавате, че дори след изтриване, лична и нелична информация може 
				остават видими в кеша или ако други потребители са го копирали или съхранили.</p>


			<h3>9. Промени в Политиката за поверителност</h3>
			<p>Може да актуализираме тази Политика за поверителност в бъдеще. Ние ще ви информираме за промените в него, като изпратим известие на посочения имейл адрес и/или като поставим известие на видно място на нашия уебсайт.</p>


			<h3>10. Контакт</h3>
			<p>Ако имате въпроси относно тази Политика за поверителност, свържете се с нас на:</p>
			<p>Имейл: {supportLink}<br> 
				Адрес: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Барселона, Испания.</p>
		`
	},
	gdpr: {
		lastUpdate: 'Последна актуализация: 10 юни 2024 г',
		content: `
			<h3>1. Кой е отговорен и как да се свържете с тях?</h3>
			<p>Администраторът на този сайт е Remove Background S.L с адрес Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Барселона, Испания.</p>
			<p>Можете да се свържете с него по имейл на {supportLink}.</p>

			<h3>2. Какви данни се събират?</h3>
			<p>
				Ние автоматично събираме данни чрез бисквитките, които зареждаме на вашето устройство, включително анализи. 
				Също така събираме IP, от който се осъществява връзката, вида на използваното устройство и неговите характеристики, 
				версията на операционната система, вида на браузъра, езика, датата, държавата, часа на заявката, 
				URL адресът, от който идвате, URL адресът, към който отивате, или използваната мобилна мрежа, между другото.<br>
				Доброволно потребителят ни предоставя информация като име и фамилия, имейл или банкова информация 
				за да можете да се свържете с нас, да се регистрирате за услугата или да закупите абонамент.
			</p>

			<h3>3. За какво се използват събраните данни?</h3>
			<p>
				Услугата ще използва събраните данни, наред с други неща, за да администрира и актуализира услугата, да отговаря на вашите заявки, 
				изпращаме ви нашия бюлетин и промоционални оферти по имейл, управляваме регистрацията ви в платформата, управляваме и предоставяме 
				услугите, свързани с вашия абонамент, обработване на плащанията, които правите и издаване на съответните фактури, 
				поддържаме сигурността на Услугата, разследваме незаконни дейности, прилагаме нашите правила и условия и 
				подпомагане на силите и органите на държавната сигурност в рамките на техните евентуални разследвания.
			</p>

			<h3>4. Колко дълго се съхраняват?</h3>
			<ul>
				<li>Разделените данни ще се съхраняват без период на изтриване.</li>
				<li>
					Клиентските данни ще се съхраняват за необходимия минимум и могат да се съхраняват до:
					<ul>
						<li>5 години, съгласно чл. 1964 от Гражданския кодекс (лични искове без специален срок).</li>
						<li>6 години, съгласно чл. 30 от Търговския закон (например счетоводни книги или фактура).</li>
					</ul>
				</li>
				<li>Потребителските данни ще бъдат съхранявани за максимален период от 12 месеца, за да се отговори на техните заявки.</li>
				<li>Потребителските данни, качени от Услугата на страници и профили в социалните мрежи, ще се съхраняват от момента, в който потребителят даде своето съгласие, докато не го оттегли.</li>
			</ul>

			<h3>5. Какви са вашите права като потребител?</h3>

			<p>
				Право на достъп: Засегнатата страна има право да получи потвърждение от администратора на данни дали 
				или не се обработват лични данни, отнасящи се до него или нея.
			</p>
			<p>
				Право на коригиране: засегнатата страна има право да получи, без неоправдано забавяне, от администратора на данни 
				коригиране на лични данни, които са неточни и го засягат пряко. По същия начин заинтересованата страна ще 
				имат право на допълване на непълни лични данни, включително чрез допълнителна декларация.
			</p>
			<p>
				Право на изтриване: Право на засегнатата страна е да получи, без неоправдано забавяне, от администратора на данни изтриването 
				на личните данни, които го засягат.
			</p>
			<p>
				Право на ограничаване на обработката на данни: състои се в получаване на ограничаване на обработката на вашите данни от отговорното лице, 
				въпреки че упражняването му има два аспекта: 1) Когато оспорвате точността на вашите лични данни, по време на период, който позволява 
				отговорното лице да го провери и 2) Когато сте възразили срещу обработването на вашите лични данни, че отговорното лице 
				извършва въз основа на легитимен интерес или мисия от обществен интерес, докато отговорното лице проверява дали тези причини 
				надделяват над вашите.
			</p>
			<p>
				Право на преносимост на данните: Правото на засегнатата страна е да получи личните данни, които го засягат, 
				че е предоставил на администратор на данни в структуриран формат за обща употреба и механично четене, и 
				да ги предаде на друг администратор, без да бъде възпрепятстван от администратора, на когото са предоставени.
			</p>
			<p>
				В този смисъл заинтересованата страна ще има право личните данни да бъдат предадени директно от администратора 
				на контролера, когато е технически възможно.
			</p>

			<h3>6. Как можете да упражните правата си?</h3>

			<p>
				Можете да упражните правата си върху личните данни по всяко време, като изпратите имейл на: {supportLink} или на пощенския адрес: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Барселона, Испания. И в двата случая трябва да се легитимирате с име и фамилия, 
				както и копие от вашия DNI или национална лична карта, ако е необходимо.<br>
				Освен това, ако смятате, че има проблем с начина, по който Remove Background обработва вашите данни, можете да насочите вашите искове 
				до <a href="{knowYourRightsLink}">органа за защита на данните</a>, който съответства, който е <a href="{aepdLink}">Испанската агенция за защита на данните</a> 
				този, посочен в случая с Испания.
			</p>

			<h3>7. Приети ли са мерки за сигурност?</h3>
			<p>
				Услугата предприема всички необходими технически и организационни мерки за защита на сигурността и неприкосновеността на личния живот 
				и събрана нелична информация. Както срещу неоторизиран достъп, така и срещу случайна промяна, загуба или унищожаване.<br>
				Във всеки случай Услугата не може да гарантира абсолютната сигурност на събраната информация, така че трябва да си сътрудничите и 
				използвайте здравия разум по всяко време по отношение на споделената информация.<br>
				Вие разбирате и потвърждавате, че дори след изтриване личната и неличната информация може да остане видима в кеша или 
				ако се копират или съхраняват от други потребители.
			</p>

			<h3>8. Има ли трансфери на лични данни или международни трансфери?</h3>

			<p>
				Ние не прехвърляме данни или международни трансфери. Има обаче трети страни, които управляват част от Услугата 
				че изискваме да спазваме нашата Политика за поверителност, доколкото тя е приложима за тях и че те имат свои собствени. 
				Тези трети страни са доставчици на услуги, които изпълняват функции от наше име, като уеб хостинг, 
				аналитичен мониторинг или уеб разработка.<br>
				Също така, ако смятаме, че е разумно необходимо да удовлетворим всеки закон, правен процес или легитимен интерес. 
				Във всеки случай ние ще предоставим само строго необходимата информация.
			</p>
		`
	},
	cookiesPolicy: {
		lastUpdate: 'Последна актуализация: 21 юни 2024 г',
		content: `
			<h3>Резюме</h3>
			<ul>
			    <li>Използвани бисквитки: <strong>собствени и на трети страни</strong></li>
			    <li>Използват ли се за получаване на статистика? <strong>Да, въз основа на законния ни интерес за по-добро управление на услугата.</strong></li>
			    <li>Услуги на трети страни, които инсталират бисквитки чрез този уебсайт: <strong>Google, Google Analytics, Cloudflare и Stripe.</strong></li>
			</ul>

			<h3>Как да конфигурирате и деактивирате бисквитките</h3>
			<p>
			    Можете да разрешите, блокирате или изтриете бисквитките, инсталирани на вашето устройство от вашия уеб браузър. Ако не разрешите инсталирането на бисквитки на вашето устройство, 
			    изживяването при сърфиране може да се влоши. По-долу можете да намерите как да конфигурирате бисквитки във всеки браузър:
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">Edge</a></li>
			    <li><a href="{externalLink: chromeCookies}">Google Chrome</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
			    <li><a href="{externalLink: operaCookies}">Opera</a></li>
			    <li><a href="{externalLink: safariCookies}">Safari</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">Safari Mobile</a></li>
			</ul>

			<h3>1. Видове и употреби</h3>
			<p>Услугата използва собствени бисквитки и бисквитки на трети страни, за да подобри сърфирането, да предостави услугата и да получи статистически данни за използването на уебсайта.</p>

			<h3>2. Какво е бисквитка и за какво се използва?</h3>
			<p>
			    Бисквитката е текстов файл, който се изпраща на вашия компютър, мобилен или таблет уеб браузър и се използва за съхраняване и извличане на информация за
			    сърфирането приключи. Например, за да запомните вашето потребителско име и парола или предпочитанията на вашия профил.
			</p>

			<h3>3. Какви видове бисквитки има?</h3>
			<p>Според това кой ги управлява:</p>
			<ul>
			    <li>Собствени бисквитки; те се изпращат до вашия браузър от нашето собствено оборудване или уеб домейни.</li>
			    <li>Бисквитки на трети страни; те се изпращат до вашия браузър от оборудване или уеб домейни, които ние не управляваме директно, а от трето лице като Google.</li>
			</ul>
			<p>В зависимост от това колко дълго остават активни, има:</p>
			<ul>
			    <li>Сесийни бисквитки; те остават във файла с бисквитки на вашия браузър, докато не напуснете уебсайта, така че никой не остава на вашето устройство.</li>
			    <li>Постоянни бисквитки; те остават на вашето устройство и нашият уебсайт ги чете при всяко ново посещение. Тези бисквитки спират да работят след определена дата.</li>
			</ul>
			<p>Накрая, според предназначението им, имаме:</p>
			<ul>
			    <li>Технически бисквитки; подобряват сърфирането и правилното функциониране на уебсайта.</li>
			    <li>Бисквитки за персонализиране; позволяват достъп до услугата с предварително зададени характеристики въз основа на поредица от критерии.</li>
			    <li>Бисквитки за анализ; те позволяват измерване и статистически анализ на използването на предоставяната услуга.</li>
			</ul>
			<p>Списък с бисквитки на трети страни, използвани от <strong>remove-background.com</strong></p>
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">Google</a>: Техните бисквитки (NID или CONSENT) позволяват персонализиране на това как се показват рекламите извън Google или съхраняване на информация
			        като например предпочитания език при показване на резултати от търсенето.<br><a href="{externalLink: googleCookieTypes}">Повече информация</a> за типовете бисквитки, които Google използва в различните си услуги.
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">Google Анализ</a>: Техните бисквитки (като _ga) позволяват да се преброи колко пъти даден потребител посещава уебсайт, как, кога и откъде.<br>
			        Във всеки случай можете да деактивирате бисквитките на Google Анализ от <a href="{externalLink: disableGoogleAnalytics}">тук</a>.
			    </li>
			    <li>Cloudflare: За да научите повече за правилата за бисквитките и използването на Cloudflare, щракнете върху <a href="{externalLink: cloudflareCookiesPolicy}">тази връзка</a>.</li>
			    <li>Stripe: Намерете информация <a href="{externalLink: stripeCookiesPolicy}">тук</a> относно правилата за бисквитките и използването на Stripe.</li>
			</ul>
		`
	}
};
